export const selectIngredients = (state) => state.ingredients;
export const selectIngredientErrors = (state) => state.ingredientErrors;
export const selectInputValue = (state) => state.inputValue;
export const selectSearchQuery = (state) => state.searchQuery;
export const selectRecipes = (state) => state.recipes;
export const selectLoading = (state) => state.loading;
export const selectNextUrl = (state) => state.nextPageUrl;
